
import { fetchApi } from '../../../../lib/fetchApi';
import { FilterDto } from '../../../../types/FilterDto';
import { DictionaryFormDto } from '../types';

export const saveData = async (body: DictionaryFormDto, table: string): Promise<DictionaryFormDto> => {
    const response = await fetchApi.post(`/${table}/save`, body) as DictionaryFormDto;
    return response;
};

export const editData = async (body: DictionaryFormDto, table: string): Promise<DictionaryFormDto> => {
    const response = await fetchApi.put(`/${table}/edit`, body) as DictionaryFormDto;
    return response;
};

export const activeData = async (id: number, table: string): Promise<void> => {
    await fetchApi.put(`/${table}/active/${id}`);
};

export const deleteData = async (id: number, table: string): Promise<void> => {
    await fetchApi.put(`/${table}/delete/${id}`);
};

export const getDetail = async (id: string, table: string): Promise<DictionaryFormDto> => {
    const response = await fetchApi.get(`/${table}/detail/${id}`) as DictionaryFormDto;
    return response;
};

export const getFilters = async (table: string): Promise<FilterDto> => {
    const response = await fetchApi.get(`/${table}/filters`) as FilterDto;
    return response;
};
